import { z } from 'zod';
import {
  compactDateFilterSchema,
  compactPicklistFilterSchema,
} from '@/common/zod-schemas/common/compactFilterSchemas';
import {
  INSIGHTS_SORT_DIRECTIONS,
  INSIGHTS_SORTABLE_FIELDS,
} from '@/features/insights-dashboard/api/types/sorting';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';

export const insightsSearchSchema = z.object({
  scopeItemId: z
    .preprocess(
      (v) => (v === '' || v === undefined ? undefined : Number(v)),
      z.number().int().positive(),
    )
    .optional(),
  teamId: compactPicklistFilterSchema,
  statusId: compactPicklistFilterSchema,
  itemTypeId: compactPicklistFilterSchema,
  plannedStartDateTime: compactDateFilterSchema,
  plannedFinishDateTime: compactDateFilterSchema,
  orderBy: z.enum(INSIGHTS_SORTABLE_FIELDS).optional(),
  orderDir: z.enum(INSIGHTS_SORT_DIRECTIONS).optional(),
});

export const insightsDeliverablesSearchSchema = insightsSearchSchema.and(itemPanelSearchSchema);
